import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import { forwardRef, useMemo } from 'react';
import 'prop-types';
import merge from 'deepmerge';
import { IconChat } from '@americanexpress/dls-icons';
import IconButton from './Base/IconButton.js';
import { dlsDeepBlueBg } from '../../styles/colorsDls/dlsDeepBlueBg.js';
import btnFloat from '../../styles/btnFloat.js';
import btn from '../../styles/btn.js';
import btnFloatingChat from '../../styles/btnFloatingChat.js';
import { jsx } from '@emotion/core';

const ButtonFloatingChat = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    theme,
    ...otherProps
  } = props;
  const styleObject = {
    ...dlsDeepBlueBg,
    ...btn,
    ...btnFloat.btnFloat,
    zIndex: 1
  };
  const cssStyle = useMemo(() => merge.all([btnFloatingChat.btnFloatingChat, {
    // get the styles for each screen size
    '@media (min-width: 375px)': btnFloatingChat['@media (min-width: 375px)'].btnFloatingChat,
    '@media (min-width: 768px)': btnFloatingChat['@media (min-width: 768px)'].btnFloatingChat,
    '@media (min-width: 1024px)': btnFloatingChat['@media (min-width: 1024px)'].btnFloatingChat,
    '@media (min-width: 1280px)': btnFloatingChat['@media (min-width: 1280px)'].btnFloatingChat
  }, theme]), [theme]);
  return jsx("div", {
    css: cssStyle
  }, jsx(IconButton, _extends({}, otherProps, {
    ref: ref,
    icon: jsx(IconChat, null),
    theme: styleObject,
    styled: true
  }), children));
});
ButtonFloatingChat.displayName = 'ButtonFloatingChat';
ButtonFloatingChat.defaultProps = {
  theme: {},
  children: ''
};
var ButtonFloatingChat$1 = ButtonFloatingChat;

export { ButtonFloatingChat$1 as default };
